import { memo } from 'react';

import { SvgIcon } from '@material-ui/core';

import { SvgIconProps } from './SvgIcon.types';

export const ChecklistIcon = memo(({ className, fontSize = 120 }: SvgIconProps) => (
  <SvgIcon
    className={className}
    width="190"
    height="119"
    viewBox="0 0 190 119"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ fontSize, fill: 'none' }}
  >
    <path
      d="M135.077 79.5357C135.016 79.5357 135.077 79.5357 135.077 79.5357L136.721 93.4393C136.782 93.9857 137.512 94.2286 137.939 93.8643L148.109 84.3321C148.17 84.2714 148.23 84.15 148.291 84.0893L168.814 28.1107C170.153 24.4679 168.266 20.4607 164.612 19.125C160.958 17.7893 156.939 19.6714 155.599 23.3143L135.077 79.2321C135.016 79.2929 135.016 79.4143 135.077 79.5357Z"
      fill="#F0CBA7"
    />
    <path d="M152.232 32.4926L165.388 37.2823L167.226 32.2638L154.07 27.4741L152.232 32.4926Z" fill="#E8EFEA" />
    <path
      d="M137.391 93.2571L141.958 89.0071L136.66 87.0643L137.391 93.2571Z"
      fill="#E8EFEA"
      stroke="#E8EFEA"
      strokeWidth="2.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M82.7047 6.49643L71.3169 9.16786L72.474 14.2071L83.6791 11.5964C87.5156 10.6857 91.4131 13.1143 92.3265 16.9393L109.804 91.5571C110.718 95.3821 108.282 99.2679 104.445 100.179L54.2047 111.896C50.3682 112.807 46.4708 110.379 45.5573 106.554L28.0797 31.875C27.1663 28.05 29.6022 24.1643 33.4387 23.2536L44.7047 20.6429L43.5477 15.6036L32.099 18.275C25.8874 19.7321 22.0509 25.925 23.4515 32.0571L41.3554 108.314C42.8169 114.446 48.9675 118.271 55.1791 116.875L105.846 105.096C111.996 103.639 115.833 97.5071 114.432 91.3143L96.4676 15.0571C95.0669 8.86428 88.8554 5.03928 82.7047 6.49643Z"
      fill="#F0CBA7"
    />
    <path
      d="M42.0862 10.0786L43.4259 15.6643L44.583 20.7036L44.7048 21.1893C45.4355 24.2857 48.5413 26.1679 51.5862 25.4393L68.5157 21.4929C71.6214 20.7643 73.5093 17.6679 72.7785 14.6321L72.6567 14.1464L71.4996 9.10715L70.1599 3.52143L42.0862 10.0786Z"
      fill="#F0CBA7"
    />
    <path
      d="M80.8169 5.46428L69.7336 8.01428L70.9515 13.0536L81.8522 10.5036C85.6887 9.59286 89.5862 12.0214 90.4996 15.8464L107.977 90.4643C108.891 94.2893 106.455 98.175 102.618 99.0857L52.3778 110.804C48.5413 111.714 44.6439 109.286 43.7304 105.461L26.1919 30.8429C25.2785 26.9571 27.7144 23.1321 31.5509 22.2214L42.8169 19.6107L41.6599 14.5714L30.2112 17.2429C23.9996 18.7 20.1631 24.8321 21.6246 31.025L39.5285 107.282C40.99 113.414 47.1406 117.239 53.3522 115.843L104.019 104.064C110.17 102.607 114.006 96.475 112.605 90.2821L94.6406 14.025C93.1791 7.83214 87.0285 4.00714 80.8169 5.46428Z"
      stroke="#EA7200"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M51.6564 38.4142L41.4575 40.7921L43.8425 50.9603L54.0414 48.5824L51.6564 38.4142Z" fill="#E8EFEA" />
    <path d="M50.7944 70.125L52.6214 71.3393L55.788 66.2393" fill="#E8EFEA" />
    <path d="M57.3803 62.6927L47.1814 65.0705L49.5664 75.2387L59.7653 72.8609L57.3803 62.6927Z" fill="#E8EFEA" />
    <path d="M63.0449 86.9849L52.8461 89.3627L55.2311 99.5309L65.43 97.1531L63.0449 86.9849Z" fill="#E8EFEA" />
    <path
      d="M40.3202 8.98572L41.6599 14.5714L42.817 19.6107L42.9388 20.0964C43.6695 23.1929 46.7753 25.075 49.8202 24.3464L66.7497 20.4C69.8554 19.6714 71.7433 16.575 71.0125 13.5393L70.9516 13.0536L69.7337 8.01429L68.3939 2.42857L40.3202 8.98572Z"
      stroke="#EA7200"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M48.2477 36.2799L38.0488 38.6578L40.4338 48.826L50.6327 46.4481L48.2477 36.2799Z"
      stroke="#226937"
      strokeWidth="2.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M53.4131 35.0929L81.7913 28.475"
      stroke="#EA7200"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M54.5701 40.1321L73.8746 35.6393"
      stroke="#EA7200"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M55.7881 45.2322L80.8778 39.4036"
      stroke="#EA7200"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M47.3234 68L49.2112 69.1536L52.317 64.1143"
      stroke="#226937"
      strokeWidth="2.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M53.9124 60.5722L43.7135 62.95L46.0985 73.1182L56.2974 70.7404L53.9124 60.5722Z"
      stroke="#226937"
      strokeWidth="2.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M59.0765 59.3786L73.2656 56.0393"
      stroke="#EA7200"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M60.2944 64.4179L88.6726 57.8"
      stroke="#EA7200"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M61.4515 69.5179L84.4099 64.175"
      stroke="#EA7200"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M52.9868 92.2857L54.8746 93.4393L58.0413 88.4"
      stroke="#226937"
      strokeWidth="2.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M59.6363 84.8506L49.4374 87.2284L51.8224 97.3966L62.0213 95.0188L59.6363 84.8506Z"
      stroke="#226937"
      strokeWidth="2.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M64.8009 83.6643L93.1791 77.0464"
      stroke="#EA7200"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M65.958 88.7036L94.3971 82.0857"
      stroke="#EA7200"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M67.1759 93.8036L83.6791 89.9786"
      stroke="#EA7200"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M155.355 35.6393L143.663 67.7571"
      stroke="#EA7200"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M160.593 21.3714C163.881 22.5857 165.525 26.1679 164.368 29.3857L143.846 85.3643L132.032 81.0536L152.554 25.075C153.772 21.8571 157.365 20.1571 160.593 21.3714Z"
      stroke="#EA7200"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M133.676 94.8964L143.907 85.3643L132.032 81.0536L133.676 94.8964Z"
      stroke="#EA7200"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M138.243 90.6464L133.067 88.7036"
      stroke="#F05A28"
      strokeWidth="2.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M149.484 33.4786L161.324 37.7894L163.162 32.7709L151.322 28.4601L149.484 33.4786Z"
      stroke="#226937"
      strokeWidth="2.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M141.836 72.6143L139.705 78.5036"
      stroke="#EA7200"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M133.676 94.8964L138.243 90.6464L132.945 88.7036L133.676 94.8964Z"
      stroke="#226937"
      strokeWidth="2.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
));
